import { Component } from '@angular/core';

@Component({
   selector: 'app-download-app',
   templateUrl: './dowload-app.component.html',
   styleUrls: ['./dowload-app.component.css'],
})
export class DownloadAppComponent { }
